import { BasePluginData } from './base-plugin-data';

/**
 * Represents customer details and allocation schedule data for a resource
 */
export class CustomerAllocationData extends BasePluginData {
  override get pluginStepName(): string { return 'CustomerAllocationData'; }

  /**
   * Selected customer ID
   */
  customerId: string = '';

  /**
   * Name of the customer to be displayed on the UI
   */
  customerName: string = "";

  /**
   * List of participants (entered manually)
   */
  participants: string[] = [];

  /**
   * Schedule type for allocation (e.g., 'immediate', 'scheduled', 'manual')
   */
  scheduleType: string = '';

  /**
   * Allocation start date (used if scheduled)
   */
  startDate: Date = new Date();

  /**
   * Allocation end date (optional)
   */
  endDate: Date = new Date();

  /**
   * Daily active hours start (e.g., 9 for 9 AM)
   */
  activeStart: number = 8;

  /**
   * Daily active hours end (e.g., 17 for 5 PM)
   */
  activeEnd: number = 20;

  /**
   * Resource removal rule
   */
  removalOption: string = '';

  /**
   * If resource removal option is time-based, this holds the datetime value
   */
  removalDateTime: any;
}
